import { render, staticRenderFns } from "./PdvListAuthorization.vue?vue&type=template&id=7b22dc31"
import script from "./PdvListAuthorization.vue?vue&type=script&lang=js"
export * from "./PdvListAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports